import { apiPost, apiPut, apiGet, apiDelete } from '@/shared/utils/requestBuilder';
import type {
  AlterarSenhaDto,
  CertificadoDigital,
  PreferenciasNotificacao,
  UploadCertificadoDto,
} from '@/types/usuario/usuarioTypes';

export const usuarioService = {
  alterarSenha: async (data: AlterarSenhaDto): Promise<{ success: boolean }> => {
    const response = await apiPost('/usuarios/alterar-senha', data);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao alterar senha' }));
      throw new Error(errorData.error || 'Erro ao alterar senha');
    }
    const result = await response.json();
    return result.data || { success: true };
  },

  uploadCertificado: async (data: UploadCertificadoDto): Promise<CertificadoDigital> => {
    const form = new FormData();
    form.append('arquivo', data.arquivo);
    form.append('expiracao', String(data.expiracao));
    if (data.senha) {
      form.append('senha', data.senha);
    }

    const response = await apiPost('/usuarios/certificado', form);
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao enviar certificado' }));
      throw new Error(errorData.error || 'Erro ao enviar certificado');
    }
    const result = await response.json();
    return result.data;
  },

  obterCertificadoAtivo: async (): Promise<CertificadoDigital | null> => {
    const response = await apiGet('/usuarios/certificado/ativo');
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao buscar certificado' }));
      throw new Error(errorData.error || 'Erro ao buscar certificado');
    }
    const result = await response.json();
    return result.data;
  },

  listarCertificados: async (): Promise<CertificadoDigital[]> => {
    const response = await apiGet('/usuarios/certificado');
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao buscar certificados' }));
      throw new Error(errorData.error || 'Erro ao buscar certificados');
    }
    const result = await response.json();
    return result.data || [];
  },

  removerCertificado: async (certificadoId: string): Promise<void> => {
    const response = await apiDelete(`/usuarios/certificado/${certificadoId}`);
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao remover certificado' }));
      throw new Error(errorData.error || 'Erro ao remover certificado');
    }
  },

  salvarPreferencias: async (
    prefs: PreferenciasNotificacao,
  ): Promise<{ success: boolean; preferencias: PreferenciasNotificacao }> => {
    const response = await apiPut('/usuarios/preferencias-notificacao', prefs);
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao salvar preferências' }));
      throw new Error(errorData.error || 'Erro ao salvar preferências');
    }
    const result = await response.json();
    return result.data || { success: true, preferencias: prefs };
  },
};
